import { FaFacebookF, FaInstagram, FaSnapchat, FaTiktok } from "react-icons/fa6";
import { socials } from "../../data/content";

const ICONS = {
  facebook: FaFacebookF,
  instagram: FaInstagram,
  snapchat: FaSnapchat,
  tiktok: FaTiktok,
};

export default function SocialIcons({ variant = "inline", className = "" }) {
  const isButtons = variant === "buttons";

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {socials.map(({ label, icon, href }) => {
        const Icon = ICONS[icon];
        return (
          <a
            key={label}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            className={
              isButtons
                ? "flex h-12 w-12 items-center justify-center rounded-full border-2 border-white/15 text-white transition-colors duration-300 hover:border-gold-500 hover:text-gold-500"
                : "flex h-9 w-9 items-center justify-center rounded-full text-white/80 transition-colors duration-300 hover:text-gold-500"
            }
          >
            <Icon size={isButtons ? 18 : 16} />
          </a>
        );
      })}
    </div>
  );
}
